import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';

import { Observable, catchError, map, of } from 'rxjs';

import { AuthStateService } from '../service/auth-state.service';
import { TenantLifecycleService } from '../service/tenant-lifecycle.service';

const DEFAULT_FALLBACK = '/dashboard';

export const tenantWritableGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> => {
  const authState = inject(AuthStateService);
  const lifecycle = inject(TenantLifecycleService);
  const router = inject(Router);
  const fallback =
    (route.data['writableFallback'] as string | undefined) ?? DEFAULT_FALLBACK;

  return authState.ensureLoaded().pipe(
    map(() =>
      lifecycle.canWrite() ? true : router.createUrlTree([fallback]),
    ),
    catchError(() => of(router.createUrlTree([DEFAULT_FALLBACK]))),
  );
};
